import React, { useEffect } from "react";
import "../../Style/ClientRateSection.css";
import { myCustomTheme } from "../../Theme";
import ClientRateImage from "../../Assets/3d-printer.png";

const ClientRateSection = () => {

    const theme = myCustomTheme;

    const features = [
        "Expertise and Experience",
        "State-of-the-Art Technology",
        "Custom Solutions",
        "Fast Turnaround Times",
        "High-Quality Standards",
        "Affordable Pricing",
        "Sustainable Practices",
        "Dedicated Customer Support",
    ];

    // SECTION OPEN ANIMATION
    useEffect(() => {

        const section = document.querySelector(".client-rate-section");

        const observer = new IntersectionObserver(
            (entries) => {

                entries.forEach((entry) => {

                    if (entry.isIntersecting) {
                        entry.target.classList.add("show");
                    }

                });

            },
            { threshold: 0.2 }
        );

        if (section) {
            observer.observe(section);
        }

        return () => {
            if (section) {
                observer.unobserve(section);
            }
        };

    }, []);

    return (
        <section
            className="client-rate-section"
            style={{
                background: `
                    linear-gradient(
                        135deg,
                        #000 0%,
                       #001530e0 100%
                    )
                `,
                fontFamily: theme.typography.text_font,
            }}
        >

            {/* BG GRID */}
            <div className="client-bg-animation"></div>

            <div
                className="client-rate-container"
                style={{
                    maxWidth: theme.spacing.container_max,
                }}
            >

                {/* LEFT SIDE */}
                <div className="client-rate-left">

                    <span
                        className="client-rate-subtitle"
                        style={{
                            color: "#ff9f1c",
                            fontFamily: theme.typography.text_font,
                            fontSize: theme.typography.menu_size,
                        }}
                    >
                        WHY WE STAND OUT
                    </span>

                    <h1
                        className="client-rate-heading"
                        style={{
                            color: theme.colors.p_text,
                            fontFamily: theme.typography.heading_font,
                        }}
                    >
                        Leading the Way in
                        <br />
                        3D Printing
                    </h1>

                    <p
                        className="client-rate-text"
                        style={{
                            color: theme.colors.p_text,
                            fontFamily: theme.typography.text_font,
                        }}
                    >
                        We provide innovative and premium 3D printing
                        solutions using advanced technology and precision
                        manufacturing to transform your ideas into reality.
                    </p>

                    {/* FEATURES */}
                    <div className="client-feature-grid">

                        {features.map((item, index) => (
                            <div
                                key={index}
                                className="client-feature-item"
                                style={{
                                    animationDelay: `${index * 0.15}s`
                                }}
                            >

                                <div
                                    className="client-check-icon"
                                    style={{
                                        color: "#ff9f1c",
                                        border: "1.5px solid #ff9f1c",
                                    }}
                                >
                                    ✓
                                </div>

                                <span
                                    style={{
                                        color: theme.colors.p_text,
                                        fontFamily: theme.typography.text_font,
                                    }}
                                >
                                    {item}
                                </span>

                            </div>
                        ))}

                    </div>

                </div>

                {/* RIGHT SIDE */}
                <div className="client-rate-right">

                    {/* PROGRESS */}
                    <div className="progress-wrapper">

                        <div className="progress-item">

                            <div
                                className="progress-header"
                                style={{
                                    color: theme.colors.p_text,
                                    fontFamily: theme.typography.text_font,
                                }}
                            >
                                <span>Client Satisfaction Rate</span>
                                <span>95%</span>
                            </div>

                            <div
                                className="progress-bar"
                                style={{
                                    background: `${theme.colors.p_text}20`,
                                }}
                            >

                                <div
                                    className="progress-fill fill-95"
                                    style={{
                                        background: "#ff9f1c",
                                    }}
                                ></div>

                            </div>

                        </div>

                        <div className="progress-item">

                            <div
                                className="progress-header"
                                style={{
                                    color: theme.colors.p_text,
                                    fontFamily: theme.typography.text_font,
                                }}
                            >
                                <span>Innovative Technology</span>
                                <span>90%</span>
                            </div>

                            <div
                                className="progress-bar"
                                style={{
                                    background: `${theme.colors.p_text}20`,
                                }}
                            >

                                <div
                                    className="progress-fill fill-90"
                                    style={{
                                        background: "#ff9f1c",
                                    }}
                                ></div>

                            </div>

                        </div>

                    </div>

                    {/* IMAGE */}
                    <div
                        className="client-image-wrapper"
                        style={{
                            borderRadius: theme.spacing.border_radius,
                        }}
                    >

                        <img
                            src={ClientRateImage}
                            alt="3D Printing"
                            className="client-image"
                        />

                    </div>

                </div>

            </div>

        </section>
    );
};

export default ClientRateSection;